import { useParams } from "react-router-dom";

export const useSourceCreatePageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
